var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 51.2041C21.5 51.2041 0 72.7041 0 99.2041C0 114.304 7.1 128.504 19.2 137.604L236.8 300.804C248.2 309.304 263.8 309.304 275.2 300.804L492.8 137.604C504.9 128.504 512 114.304 512 99.2041C512 72.7041 490.5 51.2041 464 51.2041H48ZM0 163.204V371.204C0 406.504 28.7 435.204 64 435.204H448C483.3 435.204 512 406.504 512 371.204V163.204L294.4 326.404C271.6 343.504 240.4 343.504 217.6 326.404L0 163.204Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.722378f4b239e7ddefdd4c0ea17b33df.svg";
export { ForwardRef as ReactComponent };